import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { UpdateOrganizationProfileRequest } from '@nucleus-commerce/api-client/admin';

import { session } from '@/shared/session/session';

import { organizationSettingsApi } from '../api/organization-settings-api';

import { organizationSettingsKeys } from './organization-settings-keys';

export function organizationProfileQueryOptions() {
  return queryOptions({
    queryKey: organizationSettingsKeys.profile,
    queryFn: organizationSettingsApi.profile,
  });
}

export function useOrganizationProfile(enabled = true) {
  return useQuery({ ...organizationProfileQueryOptions(), enabled });
}

/** The name shows in the shell from /me, so the session is refreshed after a save. */
export function useUpdateOrganizationProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateOrganizationProfileRequest) =>
      organizationSettingsApi.updateProfile(body),
    meta: { successMessage: 'organization:profile.saved', silentError: true },
    onSuccess: async (profile) => {
      queryClient.setQueryData(organizationSettingsKeys.profile, profile);
      await session.refreshSession(queryClient);
    },
  });
}
